var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrikeSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3125 0.780029C8.88306 0.780029 10.1562 2.00229 10.1562 3.51003V3.90003C10.1562 4.11543 9.97437 4.29003 9.75 4.29003C9.52563 4.29003 9.34375 4.11543 9.34375 3.90003V3.51003C9.34375 2.43308 8.43432 1.56003 7.3125 1.56003H5.6875C4.56568 1.56003 3.65625 2.43308 3.65625 3.51003V3.90003C3.65625 4.97662 4.56503 5.8494 5.68632 5.85003H5.6875H7.3125H11.7812C12.0056 5.85003 12.1875 6.02463 12.1875 6.24003C12.1875 6.45543 12.0056 6.63003 11.7812 6.63003H9.30272C9.82942 7.12552 10.1562 7.81614 10.1562 8.58003V8.97003C10.1562 10.4778 8.88306 11.7 7.3125 11.7H5.6875C4.11694 11.7 2.84375 10.4778 2.84375 8.97003V8.58685C2.84375 8.37146 3.02564 8.19685 3.25 8.19685C3.47436 8.19685 3.65625 8.37146 3.65625 8.58685V8.97003C3.65625 10.047 4.56568 10.92 5.6875 10.92H7.3125C8.43432 10.92 9.34375 10.047 9.34375 8.97003V8.58003C9.34375 7.50308 8.43432 6.63003 7.3125 6.63003H5.6875H5.68612H1.21875C0.994386 6.63003 0.8125 6.45543 0.8125 6.24003C0.8125 6.02463 0.994386 5.85003 1.21875 5.85003H3.69729C3.17057 5.35453 2.84375 4.66392 2.84375 3.90003V3.51003C2.84375 2.00229 4.11694 0.780029 5.6875 0.780029H7.3125Z",
    fill: "#181038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikeSmall);
export default __webpack_public_path__ + "static/media/strike-small.00bf8b90b0f12b3c420872e4bfa2f382.svg";
export { ForwardRef as ReactComponent };